module.exports = __webpack_public_path__ + "static/media/PackTrackScreen.e0f94eae.png";